<template>
    <aside class="delivery-sec__aside">
        <nav class="delivery-sec__nav">
            <ul class="list delivery-nav-list">
                <li class="list__element delivery-nav-list__element ":class="page === 'delivery'? 'active-link' : '' ">
                    <a href="/delivery" class="delivery-nav-list__link" >
                        {{trans("Delivery")}}
                    </a>
                </li>
                <li class="list__element delivery-nav-list__element ":class="page === 'payment'? 'active-link' : '' ">
                    <a href="/payment" class="delivery-nav-list__link" >
                        {{ trans("Payment") }}

                    </a>
                </li>
                <li class="list__element delivery-nav-list__element ":class="page === 'sizes'? 'active-link' : '' ">
                    <a href="/sizes" class="delivery-nav-list__link" >
                        {{trans("Size")}}
                    </a>
                </li>
                <li class="list__element delivery-nav-list__element ":class="page === 'refund'? 'active-link' : '' ">
                    <a href="/refund"  class="delivery-nav-list__link" >
                        {{trans("Refund")}}
                    </a>
                </li>
                <li class="list__element delivery-nav-list__element " :class="page === 'forbuyers'? 'active-link' : '' ">
                    <a href="/forbuyers" class="delivery-nav-list__link" >
                        {{ trans("Buyers") }}
                    </a>
                </li>
                <li class="list__element delivery-nav-list__element" :class="page === 'public-offer'? 'active-link' : '' ">
                    <a href="/public-offer" class="delivery-nav-list__link">
                        {{ trans("Offer") }}
                    </a>
                </li>
                <li class="list__element delivery-nav-list__element " :class="page === 'privacy-policy'? 'active-link' : '' ">
                    <a href="/privacy-policy" class="delivery-nav-list__link">
                        {{ trans("privacy policy") }}
                    </a>
                </li>
            </ul>
        </nav>
    </aside>
</template>

<script>



export default {
    props:{
        page:String
    },
    name: "aside-bar-public",


}
</script>

<style scoped>

</style>
